import { damageReport } from '@app/shared/constants';
import { StringUtility } from './../../string-utility';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import { sumBy } from 'lodash';

@Component({
  selector: 'app-upload-box',
  templateUrl: './upload-box.component.html',
  styleUrls: ['./upload-box.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UploadBoxComponent implements OnInit {
  isUploadError = false;
  fileUploader: FileUploader;
  @Input() maxFileSizeInMb!: number;
  @Input() maxTotalFileSizeInMb!: number;
  @Input() allowedFileTypes!: string[];
  @Input() allowedMimeTypes!: string[];
  @Input() fileInputAccept!: string;
  @Input() queueLimit!: number;
  @Output() fileAdded: EventEmitter<FileItem> = new EventEmitter();
  @Output() fileAddFailed: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.fileUploader = new FileUploader({
      maxFileSize: this.maxFileSizeInMb * 1024 * 1024,
      allowedMimeType: this.allowedMimeTypes,
      allowedFileType: this.allowedFileTypes,
      queueLimit: this.queueLimit,
      url: '',
    });
  }

  public ngOnInit(): void {
    this.fileUploader.onWhenAddingFileFailed = this.onWhenAddingFileFailed.bind(this);
    this.fileUploader.onAfterAddingFile = this.onAfterAddingFile.bind(this);
    this.fileUploader.onAfterAddingAll = this.onAfterAddingAll.bind(this);
  }

  private onWhenAddingFileFailed(item?: FileLikeObject, filter?: any, options?: any) {
    this.isUploadError = true;
    this.fileAddFailed.emit({
      item,
      filter,
      options,
    });
  }

  private onAfterAddingAll(items: FileItem[]): void {
    const totalCurrentSizeInMb =
      sumBy(this.queueItems, (fileItem) => {
        return fileItem.file.size;
      }) /
      1024 /
      1024;

    if (this.maxTotalFileSizeInMb && totalCurrentSizeInMb > this.maxTotalFileSizeInMb) {
      for (const file of items) {
        this.fileUploader.removeFromQueue(file);
      }
      this.onWhenAddingFileFailed(undefined, undefined, { name: 'totalFileSize' });
    } else if (this.queueItems.length > this.queueLimit) {
      this.fileUploader.queue = this.fileUploader.queue.slice(0, this.queueLimit);
      this.onWhenAddingFileFailed(undefined, undefined, { name: 'queueLimit' });
    }
  }

  private onAfterAddingFile(item: FileItem): void {
    if (StringUtility.hasAnyMatchInArray(damageReport.allowedMimeTypes, [item.file.type as string])) {
      this.isUploadError = false;
      this.fileAdded.emit(item);
    } else {
      this.fileUploader.queue.pop();
      this.onWhenAddingFileFailed(undefined, undefined, { name: 'mimeType' });
    }
  }

  public removeFromQueue(item: FileItem): void {
    this.fileUploader.removeFromQueue(item);
  }

  public get queueItems(): FileItem[] {
    return this.fileUploader.queue;
  }
}
